import 'css-chunk:src/feature/remoteClockout/RemoteClockoutModal.module.scss';export default {
  "content": "RemoteClockoutModal_content"
};